<fieldset
  class="flex flex-col gap-1.5 border-0 m-0 p-0 min-w-0"
  [class]="containerClass()">
  <legend
    class="checklist-task-label label m-0 px-0"
    [class.sr-only]="hideLabel()"
    [attr.id]="labelId">
    {{ labelText() }}
  </legend>

  <div
    class="flex flex-col gap-2"
    role="group"
    [attr.aria-labelledby]="labelId">
    @for (option of optionList; track trackByOption($index, option)) {
      <div class="text-sm">
        <label
          class="relative flex w-full min-h-10 items-center gap-3 rounded px-1 select-none"
          [class.cursor-pointer]="!state().disabled()"
          [class.cursor-not-allowed]="state().disabled()"
          [attr.for]="optionInputId($index)">
          <input
            type="checkbox"
            class="absolute inset-0 z-10 m-0 h-full w-full opacity-0"
            [class.cursor-pointer]="!state().disabled()"
            [class.cursor-not-allowed]="state().disabled()"
            [id]="optionInputId($index)"
            [disabled]="state().disabled()"
            [checked]="isSelected(option)"
            (change)="onToggle(option, $event)" />
          <span
            class="pointer-events-none flex h-6 w-6 shrink-0 items-center justify-center rounded border bg-primary transition-colors"
            [class]="
              state().disabled()
                ? 'bg-input-disabled-subtle border-disabled text-quarternary cursor-not-allowed'
                : isSelected(option)
                  ? 'border-primary text-completed-primary'
                  : 'border-primary text-primary'
            "
            [class]="
              state().touched() && state().errors().length > 0
                ? 'border-error'
                : 'border-primary'
            ">
            @if (isSelected(option)) {
              <svg-icon
                src="assets/svg/check.svg"
                svgClass="h-5 w-5 text-completed-primary"
                aria-hidden="true" />
            }
          </span>
          <span
            class="pointer-events-none leading-5"
            [class]="[
              state().disabled() ? 'text-quarternary' : 'text-primary',
              isSelected(option) ? 'font-semibold' : '',
            ]">
            {{ option }}
          </span>
        </label>
      </div>
    }
  </div>
  @if (state().touched() && state().errors().length > 0) {
    <p class="text-error-primary m-0 p-0">This is a required field</p>
  }
</fieldset>
